import { Controller } from "@hotwired/stimulus"

// クリップボードへURL等の文字列をコピーするコントローラ
//
// 使い方:
//   <button data-controller="clipboard"
//           data-clipboard-text-value="https://example.com"
//           data-clipboard-success-text-value="コピーしました"
//           data-clipboard-error-text-value="コピーに失敗しました"
//           data-action="clipboard#copy">
//     <i class="fa-regular fa-copy" data-clipboard-target="icon"></i>
//     <span data-clipboard-target="label">コピー</span>
//   </button>
export default class extends Controller {
  static values = {
    text: String,
    successText: String,
    errorText: String,
    feedbackDuration: { type: Number, default: 1800 }
  }
  static targets = ["label", "icon"]
  static classes = ["success"]

  copy(event) {
    event.preventDefault()

    this.write(this.textValue)
      .then(() => this.showFeedback(this.successTextValue, true))
      .catch(() => this.showFeedback(this.errorTextValue, false))
  }

  write(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text)
    }

    // 非セキュアコンテキスト/古いブラウザ向けのフォールバック
    return new Promise((resolve, reject) => {
      const textarea = document.createElement("textarea")
      textarea.value = text
      textarea.setAttribute("readonly", "")
      textarea.style.position = "fixed"
      textarea.style.opacity = "0"
      document.body.appendChild(textarea)
      textarea.focus()
      textarea.select()
      try {
        document.execCommand("copy") ? resolve() : reject()
      } catch (error) {
        reject(error)
      } finally {
        document.body.removeChild(textarea)
      }
    })
  }

  showFeedback(message, isSuccess) {
    if (!this.hasLabelTarget || !message) return

    if (this._originalLabel === undefined) {
      this._originalLabel = this.labelTarget.textContent
    }

    this.labelTarget.textContent = message
    if (isSuccess && this.hasSuccessClass) {
      this.element.classList.add(...this.successClasses)
    }

    clearTimeout(this._timeout)
    this._timeout = setTimeout(() => {
      this.labelTarget.textContent = this._originalLabel
      if (this.hasSuccessClass) {
        this.element.classList.remove(...this.successClasses)
      }
    }, this.feedbackDurationValue)
  }

  disconnect() {
    clearTimeout(this._timeout)
  }
}
